import { Controller } from '@hotwired/stimulus'

// Календарь расписания на телефоне (coach_schedules/_calendar): из семи
// колонок недели видна одна — выбранная в ленте дней сверху. Колонки уже в
// разметке (на компьютере видны все), переключение — только классом
// max-md:hidden, без запроса на сервер.
//
// Кнопка «+ Добавить» у тренера открывает форму с датой выбранного дня; в
// прошлое она не ведёт — форма всё равно не примет прошедшее время.
export default class CalendarDaysController extends Controller {
  static targets = ['tab', 'day', 'add']
  // Сегодня по серверу: дата из браузера в UTC после полуночи по Европе
  // отставала бы на день.
  static values = { today: String }

  select(event) {
    const day = event.params.day
    this.dayTargets.forEach((el) => {
      el.classList.toggle('max-md:hidden', el.dataset.day !== day)
    })
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.day === day
      tab.setAttribute('aria-pressed', String(active))
      tab.classList.toggle('bg-bg-blue-subtle', active)
      tab.classList.toggle('text-text-blue', active)
      tab.classList.toggle('text-text-primary', !active)
    })
    if (this.hasAddTarget) {
      const date = day > this.todayValue ? day : this.todayValue
      const url = new URL(
        this.addTarget.dataset.baseHref,
        window.location.origin
      )
      url.searchParams.set('date', date)
      this.addTarget.href = url.pathname + url.search
    }
  }
}
